import React, { useEffect, useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Events from './components/Events';
import Schedule from './components/Schedule';
import ScheduleWithHero3D from './components/ScheduleWithHero3D';
import Gallery from './components/Gallery';
import OrganizingClubs from './components/OrganizingClubs';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
const EventsPage = lazy(() => import('./pages/EventsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));

// ScrollToTop component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function HomePage() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
        <div className="text-center">
          <h1 className="text-6xl md:text-8xl font-bold mb-4 font-pricedown">STAVYA</h1>
          <div className="flex gap-2 justify-center">
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
            <div className="w-3 h-3 bg-secondary rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-3 h-3 bg-accent rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App relative">
      <CustomCursor />
      <Navbar />
      <Hero />
      <About />
      <ScheduleWithHero3D />
      {/* <Gallery /> */}
      <OrganizingClubs />
      <Footer />
    </div>
  );
}

function AboutPage() {
  return (
    <div className="App relative">
      <CustomCursor />
      <Navbar />
      <About />
      <Footer />
    </div>
  );
}

function SchedulePage() {
  return (
    <div className="App relative">
      <CustomCursor />
      <Navbar />
      <Schedule />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="fixed inset-0 flex items-center justify-center bg-background text-foreground z-50">
            <span className="text-xl font-pricedown tracking-widest">Loading…</span>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
